<cache-date></cache-date>


<period></period>


<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>


<br>


<loading [isLoad]="totalLoader"></loading>
<div *ngIf="!totalLoader && total && filter.filterParams.isShowBillingAdd" class="row">
	<div class="col-md-12">
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr>
						<th></th>
						<th>{{ 'adminstat.common.All count' | translate }}</th>
						<th>{{ 'adminstat.common.In query count' | translate }}</th>
					</tr>
				</thead>
				
				<tbody>
					<tr *ngFor="let key of ['userCount','sitesCount','sitesPublishedCount','domainsCount','activeClearSiteCount','activeFreeSiteCount','activePaidSitesCount','activePaidUsersCount','inTrial','inExpiredLt31daySiteCount','inExpiredGt31daySiteCount','isSocialSiteCount','inExtPaidSiteCount']">
						<td>
							{{ key == 'userCount' ? ('adminstat.common.' + key | translate) : ('adminstat.billing.billing.' + key | translate) }}
						</td>
						
						<td *ngFor="let type of ['total', 'inQuery']">
							{{ total && total.info && total.info[type] && total.info[type][key] ? total.info[type][key] : 0 }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="col-md-12">
		<ngb-accordion #acc="ngbAccordion">
			<ngb-panel title="{{ 'adminstat.common.referer' | translate }}">
				<ng-template ngbPanelContent>
					<table class="table">
						<thead>
							<tr>
								<th>{{ 'adminstat.common.referer' | translate }}</th>
								<th>{{ 'adminstat.common.Count' | translate }}</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let referer of total.referers">
								<td class="ul-billing-ref">
									<a *ngIf="total" [href]="'http://' + referer.referer" target="_blank" rel="noreferrer">{{ referer.referer }}</a>
									<ng-container *ngIf="!total || !referer.referer">{{ 'adminstat.common.not found' | translate }}</ng-container>
								</td>
								<td>
									{{ referer.count }}
								</td>
							</tr>
						</tbody>
					</table>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
	</div>
	<hr>
</div>


<br>
<div *ngIf="filter.filterParams.isShowBillingPeriod" class="row">
	<div class="btn-group" role="group">
		<button type="button" class="btn btn-default" aria-label="Left Align" (click)="downloadTrials()">
			<i class="fa fa-download" aria-hidden="true"></i>
		</button>
	</div>

	<div class="col-md-12">
		<chart [data]="trialChart.data" [options]="trialChart.options"></chart>
	</div>
</div>

<hr>


<div class="row">
	<div class="col-md-12">
		<chart [data]="paidChart.data" [options]="paidChart.options" (onFilterChange)="updateData($event, 'paidChart')" [sextant]="'chart'" [url]="filter.currentUrl"></chart>
	</div>
</div>

<hr><br>


<loading [isLoad]="total2Loader"></loading>
<div *ngIf="!total2Loader && total2" [sextant]="'totalTable'" [url]="filter.currentUrl">
	<ngb-accordion #acc="ngbAccordion">
		<ngb-panel title="Total" [id]="'total2'">
			<ng-template ngbPanelContent>
				<div class="row">
					<div class="col-md-12">
						<div class="table-responsive">
							<table class="table js-ul-total-billing-table" [attr.period]="filter.filterParams.period">
								<thead>
									<tr>
										<th></th>
										<th>{{ 'adminstat.common.Currency' | translate }}</th>
										<th>{{ 'adminstat.common.paidCount' | translate }}</th>
										<th>{{ 'adminstat.common.siteCount' | translate }}</th>
										<th>{{ 'adminstat.common.userCount' | translate }}</th>
										<th>{{ 'adminstat.common.Money' | translate }}</th>
									</tr>
								</thead>
	
								<tbody>
									<tr *ngFor="let currency of currencyList; let i = index">
										<td>
											{{ i == 0 ? ('adminstat.common.All count' | translate)  : '' }}
										</td>
		
										<td>
											{{ helper.currencyLabels[currency] }}
										</td>
		
										<td [sextant]="'totalCount'" [url]="filter.currentUrl">
											{{ total2.totalInfo[currency] ? total2.totalInfo[currency].paidCount : 0 }}
										</td>
		
										<td>
											{{ total2.totalInfo[currency] ? total2.totalInfo[currency].siteCount : 0 }}
										</td>
		
										<td>
											{{ total2.totalInfo[currency] ? total2.totalInfo[currency].userCount : 0 }}
										</td>
		
										<td>
											{{ total2.totalInfo[currency] ? helper.convertAmountToDollar(total2.totalInfo[currency].moneyCount, currency) : 0 }}
										</td>
									</tr>
		
									<ng-container *ngIf="!filter.filterParams.isShowCountry">
										<tr *ngFor="let currency of currencyList; let i = index">
											<td>
												{{ i == 0 ? ('adminstat.common.In query count' | translate)  : '' }}
											</td>
		
											<td>
												{{ helper.currencyLabels[currency] }}
											</td>
		
											<td>
												{{ total2.inQueryInfo[currency] ? total2.inQueryInfo[currency].paidCount : 0 }}
											</td>
		
											<td>
												{{ total2.inQueryInfo[currency] ? total2.inQueryInfo[currency].siteCount : 0 }}
											</td>
		
											<td>
												{{ total2.inQueryInfo[currency] ? total2.inQueryInfo[currency].userCount : 0 }}
											</td>
		
											<td>
												{{ total2.inQueryInfo[currency] ? helper.convertAmountToDollar(total2.inQueryInfo[currency].moneyCount, currency) : 0 }}
											</td>
										</tr>
									</ng-container>
		
									<ng-container *ngIf="filter.filterParams.isShowCountry">
										<ng-container *ngFor="let currency of currencyList; let i = index">
											<tr>
												<td>{{ i == 0 ? ('adminstat.common.In query count' | translate)  : '' }}</td>
												<td>{{ helper.currencyLabels[currency] }}</td>
												<td>{{ total2.inQueryInfo[currency].paidCount }}</td>
												<td>{{ total2.inQueryInfo[currency].siteCount }}</td>
												<td>{{ total2.inQueryInfo[currency].userCount }}</td>
												<td>{{ helper.convertAmountToDollar(total2.inQueryInfo[currency].moneyCount, currency) }}</td>
											</tr>
		
											<ng-container *ngIf="total2.countries && total2.countries[currency]">
												<tr *ngFor="let country of total2.countries[currency]; let i = index" class="info">
													<td>
														{{ (i + 1)}}
													</td>
													<td>
														{{ countriesMap[country.country] || 'adminstat.common.not found' | translate }}
													</td>
		
													<td>
														{{ country.paidCount }} ({{ helper.percentageFormat(country.paidCount / total2.inQueryInfo[currency].paidCount) }})
													</td>
		
													<td>
														{{ country.siteCount }} ({{ helper.percentageFormat(country.siteCount / total2.inQueryInfo[currency].siteCount) }})
													</td>
		
													<td>
														{{ country.userCount }} ({{ helper.percentageFormat(country.userCount / total2.inQueryInfo[currency].userCount) }})
													</td>
		
													<td>
														{{ country.moneyCount / 100 }} ({{ helper.percentageFormat(country.moneyCount / total2.inQueryInfo[currency].moneyCount) }})
													</td>
												</tr>
											</ng-container>
										</ng-container>
									</ng-container>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</ng-template>
		</ngb-panel>
	</ngb-accordion>
	<hr>
</div>
	

<loading [isLoad]="paginationLoader"></loading>
<ngb-pagination
	[extlinks]="links"
	[collectionSize]="pagination.pageCount"
	[maxSize]="10"
	[pageSize]="1"
	[(page)]="pagination.page"
	[boundaryLinks]="true"
	(pageChange)="onPageChange()"
	*ngIf="!paginationLoader && pagination.pageCount > 1"
></ngb-pagination>


<ref_status [stats]="stats"></ref_status>

<loading [isLoad]="statsLoader"></loading>
<table *ngIf="!statsLoader && stats && stats.length > 0" class="table table-bordered" [sextant]="'stats'" [url]="filter.currentUrl">
	<thead>
		<tr>
			<th>{{ 'adminstat.common.Date' | translate }}</th>
			<th>
				<div>
					<div class="row">
						<div class="col">{{ 'adminstat.common.Total info' | translate }}</div>
						<div class="col-md-auto">
							<input type="checkbox" class="form-check-input" id="hideZeroColumns" [(ngModel)]="hideZeroColumns">
							<label class="form-check-label" for="hideZeroColumns"><small>Скрыть "лишние" валюты</small></label>
						</div>
					</div>
				</div>
			</th>
		</tr>
	</thead>

	<tbody>
		<tr *ngFor="let stat of stats">
			<td [class]="stat.day == 0 || stat.day == 6 ? 'table-info' : ''">
				{{ stat.currentPeriod }}
			</td>

			<td class="js-ul-billing-info" [attr.period]="filter.filterParams.period">
				<div class="row">
					<div class="col-md-12 col-lg-12">
						<ngb-accordion #acc="ngbAccordion" [activeIds]="'panel-1-' + stat.currentPeriod">
							<ngb-panel [id]="'panel-1-' + stat.currentPeriod" title="{{ 'adminstat.billing.billing.Total' | translate }}">
								<ng-template ngbPanelContent>
									<table class="table" [zerocolumns]="hideZeroColumns">
									<thead>
										<tr>
											<th></th>
											
											<th *ngFor="let currency of ['all'].concat(currencyList)">
												{{ helper.currencyLabels[currency] }}
											</th>
										</tr>
									</thead>
										
									<tbody>
										<tr *ngFor="let key of ['paidCount', 'siteCount', 'userCount', 'moneyCount', 'promocodeCount']">
											<td>
												{{ key == 'moneyCount' ? ('adminstat.common.Money' | translate) : (key == 'promocodeCount' ? ('adminstat.common.Promocode' | translate) : ('adminstat.common.' + key | translate)) }}
											</td>
											
											<td *ngFor="let currency of ['all'].concat(currencyList)">
												<button-anhor
													[isActive]="['siteCount', 'moneyCount', 'promocodeCount'].includes(key) && currency === 'all'"
													(click)="showDetails(key, stat, stat.total[key][currency])"
													[sextant]="'details-' + key"
												>
													{{ key == 'moneyCount' ? (helper.convertAmountToDollar(stat.total.moneyCount[currency], currency)) : stat.total[key][currency] }}
												</button-anhor>
											</td>
										</tr>
									</tbody>
								</table>
								</ng-template>
							</ngb-panel>
						</ngb-accordion>
					</div>

					<div class="col-md-12 col-lg-12">
						<ngb-accordion #acc="ngbAccordion" [activeIds]="'panel-2-' + stat.currentPeriod">
							<ngb-panel [id]="'panel-2-' + stat.currentPeriod" title="{{ 'adminstat.billing.billing.Detail' | translate }}">
								<ng-template ngbPanelContent>
									<table class="table" [zerocolumns]="hideZeroColumns">
									<thead>
										<tr>
											<th>{{ 'adminstat.billing.billing.Category' | translate }}</th>
											<ng-container *ngFor="let currency of ['all'].concat(currencyList)">
												<td>
													<span title="{{ 'adminstat.common.Count' | translate }}">{{ 'adminstat.common.Count' | translate }}</span>
												</td>
												
												<td>
													{{ helper.currencyLabels[currency] }}
												</td>
											</ng-container>
										</tr>
									</thead>
									
									<tbody>
										<tr *ngFor="let key of ['firstManual', 'secondManual', 'firstRecurrent', 'secondRecurrent']">
											<td>
												{{ 'adminstat.billing.billing.' + key | translate }}
											</td>
											
											<ng-container *ngFor="let currency of ['all'].concat(currencyList)">
												<td>
													{{ stat.detail[key + 'Count'][currency] }}
												</td>
												
												<td>
													<button-anhor
														(click)="showDetails('moneyCount', stat, stat.detail[key + 'Money'][currency], key, currency)"
														[sextant]="'details-paidType-' + key + '-' + currency"
													>
														{{ helper.convertAmountToDollar(stat.detail[key + 'Money'][currency]) }}
													</button-anhor>
												</td>
											</ng-container>
										</tr>
									</tbody>
								</table>
								</ng-template>
							</ngb-panel>
						</ngb-accordion>
					</div>

					<div class="col-md-12 col-lg-12">
						<ngb-accordion #acc="ngbAccordion" [activeIds]="'panel-3-' + stat.currentPeriod">
							<ngb-panel [id]="'panel-3-' + stat.currentPeriod" title="{{ 'adminstat.billing.billing.Manual paid' | translate }}">
								<ng-template ngbPanelContent>
									<table class="table" [zerocolumns]="hideZeroColumns">
									<thead>
										<tr>
											<th>{{ 'adminstat.billing.billing.Processor' | translate }}</th>
											<th>{{ 'adminstat.common.Users' | translate }}</th>
											<th>{{ 'adminstat.common.Count' | translate }}</th>
											<th *ngFor="let currency of currencyList">
												{{ helper.currencyLabels[currency] }}
											</th>
										</tr>
									</thead>
									
									<tbody>
										<tr *ngFor="let processor of stat.paids.manual | keys">
											<td>{{ processor }}</td>
											<td>{{ stat.paids.manual[processor].userCount }}</td>
											<td>{{ stat.paids.manual[processor].paidCount }}</td>
											<td *ngFor="let currency of currencyList">
												{{ helper.convertAmountToDollar(stat.paids.manual[processor].money[currency]) }}
											</td>
										</tr>
									</tbody>
								</table>
								</ng-template>
							</ngb-panel>
						</ngb-accordion>
					</div>

					<div class="col-md-12 col-lg-12">
						<ngb-accordion #acc="ngbAccordion" [activeIds]="'panel-4-' + stat.currentPeriod">
							<ngb-panel [id]="'panel-4-' + stat.currentPeriod" title="{{ 'adminstat.billing.billing.Rebill paid' | translate }}">
								<ng-template ngbPanelContent>
									<table class="table" [zerocolumns]="hideZeroColumns">
									<thead>
									<tr>
										<th>{{ 'adminstat.billing.billing.Processor' | translate }}</th>
										<th>{{ 'adminstat.common.Users' | translate }}</th>
										<th>{{ 'adminstat.common.Count' | translate }}</th>
										<th *ngFor="let currency of currencyList">
											{{ helper.currencyLabels[currency] }}
										</th>
									</tr>
									</thead>

									<tbody>
									<tr *ngFor="let processor of stat.paids.rebill | keys">
										<td>{{ processor }}</td>
										<td>{{ stat.paids.rebill[processor].userCount }}</td>
										<td>{{ stat.paids.rebill[processor].paidCount }}</td>
										<td *ngFor="let currency of currencyList">
											{{ helper.convertAmountToDollar(stat.paids.rebill[processor].money[currency]) }}
										</td>
									</tr>
									</tbody>
								</table>
								</ng-template>
							</ngb-panel>
						</ngb-accordion>
					</div>
				</div>

				<refs [stats]="stat" [filterParams]="filter.filterParams" [currentUrl]="filter.currentUrl"></refs>
			</td>
		</tr>
	</tbody>
</table>
